export default {"src":"/_next/static/media/Attachment.a5a8dbc5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};